import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Checkbox as MuiCheckbox, FormControlLabel, Typography } from '@mui/material';

export const Checkbox = ({ name, label, ...other }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <MuiCheckbox
              {...field}
              checked={!!field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              {...other}
            />
          }
          label={
            <Typography variant="caption" color="text.primary">
              {label}
            </Typography>
          }
        />
      )}
    />
  );
};
